import jsQR from "jsqr";

export default {
  async created() {
    const cameraId = localStorage.getItem('CAMERA_ID');
    if (cameraId) {
      this.lastCameraId = cameraId;
    }

    const inputs = await navigator.mediaDevices.enumerateDevices();
    const videoSources = inputs.filter((input) => input.kind === 'videoinput');

    this.videoSourceIds = videoSources.map((videoSource) => videoSource.deviceId);
    this.currentCamera = this.videoSourceIds.findIndex((id) => id === this.lastCameraId);
    this.showToggleCamera = this.videoSourceIds.length > 1;
  },

  data() {
    return {
      canvasElement: null,
      canvas: null,
      video: null,
      isRouted: false,
      showQRFound: false,
      counter: 0,
      animationFrame: null,
      localStream: null,
      currentCamera: 0,
      lastCameraId: null,
      videoSourceIds: [],
      showToggleCamera: false,
    };
  },

  methods: {
    initiateQRReader() {
      this.video = document.createElement('video');
      this.canvasElement = document.querySelector('#qr-canvas');
      this.canvas = this.canvasElement.getContext('2d');
    },

    async startQr() {
      this.initiateQRReader();
      let mediaRequest = {};
      if (this.lastCameraId) {
        mediaRequest = {
          deviceId: {
            exact: this.lastCameraId
          }
        };
      }
      this.localStream = await navigator.mediaDevices.getUserMedia({video: mediaRequest});
      this.video.srcObject = this.localStream;
      this.video.play();
      this.isLoaded = true;
      this.animationFrame = setInterval(this.start, 1000 / 60);
    },

    start() {
      requestAnimationFrame(this.tick);
    },

    stop() {
      clearInterval(this.animationFrame);
      this.video.pause();
      this.localStream.getTracks().forEach((track) => {
        track.stop();
      });
      this.video.remove();
      this.video = null;
      this.$emit('close');
    },

    tick() {
      const video = this.video;
      if (video.readyState !== video.HAVE_ENOUGH_DATA) return;

      const canvasElement = this.canvasElement;
      canvasElement.hidden = false;
      canvasElement.height = video.videoHeight;
      canvasElement.width = video.videoWidth;

      const canvas = this.canvas;
      canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
      const imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert",
      });

      if (code) {
        const redirectUrl = code.data;
        const basePath = window.location.host;
        if (!redirectUrl.includes(basePath)) {
          return;
        }

        window.location.href = redirectUrl;
        this.stop();
      }
    },

    async swapCamera() {
      const stream = this.localStream;
      const tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });

      this.currentCamera++;
      const newIndex = this.currentCamera % this.videoSourceIds.length
      localStorage.setItem('CAMERA_ID', this.videoSourceIds[newIndex])

      let requestDeviceId = this.videoSourceIds[newIndex] ? {exact: this.videoSourceIds[newIndex]} : undefined
      const newStream = await navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: requestDeviceId
          }
        });

      this.video.srcObject = newStream;
      this.video.play();
      this.localStream = newStream;
      this.isInitial = false;
    }
  }
}
